export default function formatDateString(date) {
  if (!date) {
    return '';
  }
  const dateObj = new Date(date);
  // eslint-disable-next-line no-restricted-globals
  return (dateObj instanceof Date && !isNaN(dateObj))
    ? `${dateObj.toLocaleString('en-US', { hour12: true })}` : '';
}
